import request from '@utils/request';
import { NavigationLabelSchema } from './schemas';

export async function getNavigationLabels({ siteSlug }: { siteSlug: string }) {
  const response = await request.v2.get(`/store/pages/site/${siteSlug}/terminology`);
  return NavigationLabelSchema.parse(response.data.data);
}
